import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';
import DayContent from './pages/DayContent';
import Attendance from './pages/Attendance';
import PSR from './pages/PSR';
import Profile from './pages/Profile';
import PSRReport from './pages/PSRReport';
import JobTimeline from './pages/JobTimeline';
import Users from './pages/supervisor/Users';
import CourseBuilder from './pages/supervisor/CourseBuilder';
import Assignments from './pages/supervisor/Assignments';
import AttendanceManager from './pages/supervisor/AttendanceManager';
import PSRManager from './pages/supervisor/PSRManager';
import CSVImport from './pages/supervisor/CSVImport';
import Reports from './pages/supervisor/Reports';
import PSRReview from './pages/supervisor/PSRReview';

function PrivateRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function SupervisorRoute({ children }) {
  const { isAuthenticated, isSupervisor } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!isSupervisor)    return <Navigate to="/"      replace />;
  return children;
}

function AppRoutes() {
  const { isAuthenticated } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <Login />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="courses" element={<Courses />} />
        <Route path="courses/:id" element={<CourseDetail />} />
        <Route path="courses/:courseId/week/:weekNo/day/:dayNo" element={<DayContent />} />
        <Route path="attendance" element={<Attendance />} />
        <Route path="psr" element={<PSR />} />
        <Route path="profile" element={<Profile />} />
        <Route path="psr-report"   element={<PSRReport />} />
        <Route path="job-timeline" element={<JobTimeline />} />
        {/* Supervisor */}
        <Route path="users"            element={<SupervisorRoute><Users /></SupervisorRoute>} />
        <Route path="course-builder"   element={<SupervisorRoute><CourseBuilder /></SupervisorRoute>} />
        <Route path="course-builder/:id" element={<SupervisorRoute><CourseBuilder /></SupervisorRoute>} />
        <Route path="assignments"      element={<SupervisorRoute><Assignments /></SupervisorRoute>} />
        <Route path="attendance-mgr"   element={<SupervisorRoute><AttendanceManager /></SupervisorRoute>} />
        <Route path="psr-mgr"          element={<SupervisorRoute><PSRManager /></SupervisorRoute>} />
        <Route path="csv-import"       element={<SupervisorRoute><CSVImport /></SupervisorRoute>} />
        <Route path="reports"          element={<SupervisorRoute><Reports /></SupervisorRoute>} />
        <Route path="psr-review"       element={<SupervisorRoute><PSRReview /></SupervisorRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
